import { __decorate } from "tslib";
import { html } from 'lit';
import { CipublicElement } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/mixins/base.js';
import { property, state, query } from 'lit/decorators.js';
import { debounce } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/utils/debounce.js';
import { emit } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/utils/event.js';
import { gridBreakpoints } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/utils/breakpoints.js';
import '@cigna/cigna_csg_gsg_cipublic-backdrop/cipublic-backdrop.js';
import '@cigna/cigna_csg_gsg_cipublic-close-button/cipublic-close-button.js';
import '@cigna/cigna_csg_gsg_cipublic-focus-trap/cipublic-focus-trap.js';
import styles from './modal.scss.js';
/**
 * @element cipublic-modal
 */
export class Modal extends CipublicElement {
    constructor() {
        super(...arguments);
        this.scrollable = false;
        this.dialog = false;
        this.fullWidth = false;
        this.openOnLoad = false;
        this.size = '';
        this.active = false;
        this.emitConnectedCallback = false;
    }
    get isMobile() {
        return !window.matchMedia(`(min-width: ${gridBreakpoints.md}px)`).matches;
    }
    connectedCallback() {
        super.connectedCallback();
        if (this.emitConnectedCallback) {
            emit(this, 'connected-callback');
        }
    }
    static get styles() {
        return [styles];
    }
    render() {
        return html `<div class="modal fade modal-position" id="${this.id}"><div class="modal-dialog modal-dialog-centered ${this.size}" role="document"><cipublic-focus-trap><div class="modal-content"><div class="modal-header ${this.hasCloseButton ? 'has-close-button' : ''}">${this.hasCloseButton
            ? html `<cipublic-close-button class="dismiss" @click="${this.toggleModal}" ?showLabel="${this.showCloseLabel}" aria-hidden="true" tabindex="-1"></cipublic-close-button>`
            : ''}<slot name="heading"></slot></div><div class="modal-body" tabindex="-1"><slot></slot></div><div class="modal-footer"><slot name="dismiss-dialog-btn"></slot><slot name="footer"></slot></div></div></cipublic-focus-trap></div></div><cipublic-backdrop ?active="${this.active}"></cipublic-backdrop>`;
    }
    toggleModal() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        this.active ? (this.active = false) : (this.active = true);
        ((_a = this.modalBody) === null || _a === void 0 ? void 0 : _a.getAttribute('tabindex')) === '0'
            ? (_b = this.modalBody) === null || _b === void 0 ? void 0 : _b.setAttribute('tabindex', '-1')
            : (_c = this.modalBody) === null || _c === void 0 ? void 0 : _c.setAttribute('tabindex', '0');
        this.modalDialog.classList.toggle('show');
        this.modalDialog.classList.toggle('modal-position');
        ((_d = this.closeButton) === null || _d === void 0 ? void 0 : _d.hasAttribute('aria-hidden'))
            ? (_e = this.closeButton) === null || _e === void 0 ? void 0 : _e.removeAttribute('aria-hidden')
            : (_f = this.closeButton) === null || _f === void 0 ? void 0 : _f.setAttribute('aria-hidden', 'true');
        ((_g = this.closeButton) === null || _g === void 0 ? void 0 : _g.hasAttribute('tabindex'))
            ? (_h = this.closeButton) === null || _h === void 0 ? void 0 : _h.removeAttribute('tabindex')
            : (_j = this.closeButton) === null || _j === void 0 ? void 0 : _j.setAttribute('tabindex', '-1');
        this.toggleSlotsAria();
        this.focusTrap.toggleAttribute('trapped');
        this.adjustModalHeight();
        // @ts-ignore next-line
        if (this.active)
            this.focusTrap.firstFocusElement.focus();
        else
            (_k = this.buttonModalTrigger) === null || _k === void 0 ? void 0 : _k.focus();
        document.addEventListener('keydown', (keyPress) => {
            if (keyPress.key === 'Escape') {
                this.toggleModal();
            }
        });
        const mediaElement = this.querySelector('cipublic-multimedia');
        if (!this.active && mediaElement) {
            if (mediaElement === null || mediaElement === void 0 ? void 0 : mediaElement.querySelector('video')) {
                (_l = mediaElement === null || mediaElement === void 0 ? void 0 : mediaElement.querySelector('video')) === null || _l === void 0 ? void 0 : _l.pause();
            }
            else if (mediaElement === null || mediaElement === void 0 ? void 0 : mediaElement.querySelector('audio')) {
                (_m = mediaElement === null || mediaElement === void 0 ? void 0 : mediaElement.querySelector('audio')) === null || _m === void 0 ? void 0 : _m.pause();
            }
        }
        this.modalBody.addEventListener('focus', () => {
            var _a, _b, _c, _d, _e;
            const formComponent = this.querySelector('cipublic-eloqua-form'); // selects Eloqua Form component in the modal
            const EloquaForm = (_a = formComponent === null || formComponent === void 0 ? void 0 : formComponent.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('cipublic-form'); // Selects the injected form
            const focusableElements = 'cipublic-input:not([type="hidden"]), cipublic-textarea, cipublic-select, cipublic-checkbox, cipublic-button'; // Grab all input types
            const FormFields = EloquaForm === null || EloquaForm === void 0 ? void 0 : EloquaForm.querySelectorAll(focusableElements); // Collection of all input fields
            // Cycle through ELOQUA Form fields
            if (EloquaForm) {
                // @ts-ignore - fix later
                FormFields === null || FormFields === void 0 ? void 0 : FormFields.forEach((focusableComponent) => {
                    var _a;
                    const fieldName = (focusableComponent).name;
                    const focusablefield = (_a = focusableComponent === null || focusableComponent === void 0 ? void 0 : focusableComponent.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.element-wrapper > .element-parent > [name="' + fieldName + '"]');
                    if (focusablefield) {
                        focusablefield.setAttribute('tabindex', '0');
                    }
                });
                let focusPosition = 0;
                const FirstInput = (_c = (_b = EloquaForm === null || EloquaForm === void 0 ? void 0 : EloquaForm.querySelector(focusableElements)) === null || _b === void 0 ? void 0 : _b.shadowRoot) === null || _c === void 0 ? void 0 : _c.querySelector('.element-wrapper > .element-parent > [tabindex="0"]');
                const SubmitButton = (_e = (_d = EloquaForm === null || EloquaForm === void 0 ? void 0 : EloquaForm.querySelector('cipublic-button')) === null || _d === void 0 ? void 0 : _d.shadowRoot) === null || _e === void 0 ? void 0 : _e.querySelector('button');
                if (FirstInput && SubmitButton) {
                    SubmitButton.addEventListener('blur', () => {
                        FirstInput.focus();
                        focusPosition = 1;
                    });
                    document.addEventListener('keydown', (keyPress) => {
                        if (keyPress.key === 'Tab') {
                            if (focusPosition < 2) {
                                FirstInput.focus();
                                focusPosition = 1;
                            }
                            focusPosition++;
                        }
                    });
                }
            }
        });
        // ELOQUA Form - thank you alert focus trap & dismiss
        const formContainer = this.querySelector('cipublic-eloqua-form');
        if (formContainer) {
            formContainer.addEventListener('eloqua-fetch.success', () => {
                focusCloseOnEloquaSubmit();
            });
            formContainer.addEventListener('eloqua-fetch.error', () => {
                focusCloseOnEloquaSubmit();
            });
        }
        const focusCloseOnEloquaSubmit = () => {
            var _a, _b, _c;
            const eloquaInputs = (_a = formContainer === null || formContainer === void 0 ? void 0 : formContainer.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('cipublic-form');
            if (!(eloquaInputs)) {
                if (this.closeButton) {
                    (_c = (_b = this.closeButton.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector('button')) === null || _c === void 0 ? void 0 : _c.focus();
                }
            }
        };
    }
    toggleModalChecker(event) {
        const { detail } = event;
        if (detail.event) {
            this.buttonModalTrigger = detail.event.currentTarget;
        }
        else {
            this.buttonModalTrigger = detail.target;
        }
        const modalOpen = detail.modalToggle;
        const modalTarget = detail.modalTarget;
        if (modalOpen && modalTarget && this.id === modalTarget)
            this.toggleModal();
    }
    addListeners() {
        window.addEventListener('modal.toggle', this.toggleModalChecker.bind(this));
        this.modalDialog.addEventListener('click', (e) => {
            if (e.target && e.target.id && this.hasCloseButton)
                this.toggleModal();
        });
        this.dialogDismissButton.addEventListener('click', () => {
            this.toggleModal();
        });
    }
    toggleSlotsAria() {
        this.hasAttribute('aria-hidden') ? this.removeAttribute('aria-hidden') : this.setAttribute('aria-hidden', 'true');
        const allSlots = this.children;
        [].forEach.call(allSlots, (singleSlot) => {
            singleSlot.hasAttribute('hidden') ? singleSlot.removeAttribute('hidden') : singleSlot.setAttribute('hidden', 'true');
        });
    }
    adjustModalHeight() {
        const delay = this.isMobile ? 500 : 0;
        const modalContentPadding = '24px';
        const modalBodyPaddingMargin = '64px';
        const viewportSpacing = '32px';
        if (this.fullWidth) {
            setTimeout(() => (this.modalBody.style.maxHeight = `calc(100vh - (${this.modalHeader.clientHeight}px + 24px))`), 500);
        }
        if (this.scrollable) {
            setTimeout(() => (this.modalBody.style.maxHeight = this.isMobile
                ? `calc(100vh - (${this.modalHeader.clientHeight}px + ${this.modalFooter.clientHeight}px + ${modalContentPadding} + ${modalBodyPaddingMargin} + ${viewportSpacing}))`
                : 'var(--max-modal-height)'), delay);
        }
    }
    async firstUpdated(changedProperties) {
        super.firstUpdated(changedProperties);
        if (this.openOnLoad) {
            this.toggleModal();
        }
        await this.updateComplete;
        this.addListeners();
        this.toggleSlotsAria();
        this.adjustModalHeight();
        window.addEventListener('resize', debounce(this.adjustModalHeight.bind(this), 200));
    }
}
__decorate([
    property({ type: Boolean, reflect: true, attribute: 'scrollable' })
], Modal.prototype, "scrollable", void 0);
__decorate([
    property({ type: Boolean, reflect: true, attribute: 'dialog' })
], Modal.prototype, "dialog", void 0);
__decorate([
    property({ type: Boolean })
], Modal.prototype, "fullWidth", void 0);
__decorate([
    property({ type: Boolean })
], Modal.prototype, "openOnLoad", void 0);
__decorate([
    property({ type: Boolean })
], Modal.prototype, "hasCloseButton", void 0);
__decorate([
    property({ type: Boolean })
], Modal.prototype, "showCloseLabel", void 0);
__decorate([
    property()
], Modal.prototype, "target", void 0);
__decorate([
    property()
], Modal.prototype, "id", void 0);
__decorate([
    property()
], Modal.prototype, "size", void 0);
__decorate([
    query('.modal')
], Modal.prototype, "modalDialog", void 0);
__decorate([
    query('.modal-header')
], Modal.prototype, "modalHeader", void 0);
__decorate([
    query('.modal-body')
], Modal.prototype, "modalBody", void 0);
__decorate([
    query('.modal-footer')
], Modal.prototype, "modalFooter", void 0);
__decorate([
    query('[name="dismiss-dialog-btn"]')
], Modal.prototype, "dialogDismissButton", void 0);
__decorate([
    query('cipublic-close-button')
], Modal.prototype, "closeButton", void 0);
__decorate([
    query('cipublic-focus-trap')
], Modal.prototype, "focusTrap", void 0);
__decorate([
    state()
], Modal.prototype, "active", void 0);
__decorate([
    state()
], Modal.prototype, "isMobile", null);
__decorate([
    property({ reflect: true, type: Boolean })
], Modal.prototype, "emitConnectedCallback", void 0);
//# sourceMappingURL=modal.js.map